import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  FORM_STEPS,
  BobtailStore
} from './../../shared/index';

@Injectable()
export class NavService {
  storeData;
  activeStep = '';
  completedSteps = [];
  inactiveSteps = [];

  constructor(
    private _store: Store<any>
  ) {
    this.storeData = this._store.select('cvform').subscribe((store: BobtailStore) => {
      this.completedSteps = Object.keys(store.steps);

      this.activeStep = FORM_STEPS.map(step => step.id).reduce((prev, curr) => {
        if (this.completedSteps.includes(curr) || prev !== '') {
          return prev;
        } else {
          return curr;
        }
      }, '');

      this.inactiveSteps = FORM_STEPS.map(step => step.id).filter(stepId => {
        return !this.completedSteps.includes(stepId) && stepId !== this.activeStep;
      });
    });
  }

  manualActiveStep(stepId) {
    this.activeStep = stepId;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/navigation/navigation.service.ts